module.exports = __webpack_public_path__ + "static/media/type_assign_activity_role.e094448f.jpg";